import WeeklyOvertime from "./WeeklyOvertime";
import DailyOvertime from "./DailyOvertime";
import DailyDoubleTime from "./DailyDoubleTime";
import DailyDoubleTimeHalf from "./DailyDoubleTimeHalf";
import AllHoursWorkedOn from "./AllHoursWorkedOn";
import ConsecutiveOvertimeRule from "./ConsecutiveOvertime";
import "./style.scss";

function Rule({ type, disabled }) {
	switch (type) {
		case "weekly-overtime":
			return <WeeklyOvertime disabled={disabled} />;
		case "daily-overtime":
			return <DailyOvertime disabled={disabled} />;
		case "daily-double-time":
			return <DailyDoubleTime disabled={disabled} />;
		case "daily-double-time-and-half":
			return <DailyDoubleTimeHalf disabled={disabled} />;
		case "consecutive-day":
		case "six-consecutive-day":
		case "five-consecutive-day":
		case "four-consecutive-day":
			return <ConsecutiveOvertimeRule ruleType={type} disabled={disabled} />;
		case "all-hours-worked-on":
			return <AllHoursWorkedOn disabled={disabled} />;
		default:
			return <div>Rule {type} is not implemented yet</div>;
	}
}

export default Rule;
